import * as Yup from "yup";

export const personalDetailsValidations = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required("First Name is required")
    .matches(/^[A-Za-z\s]+$/, "First Name can only contain letters and spaces"),

  last_name: Yup.string()
    .trim()
    .required("Last Name is required")
    .matches(/^[A-Za-z\s]+$/, "Last Name can only contain letters and spaces"),
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  mobile_number: Yup.string()
    .trim()
    .matches(
      /^(?:\+(\d{1,3})\s?)?(\(\d{3}\)\s?\d{3}-\d{4})$/,
      "Invalid phone number format. { e.g., +1 (123) 456-7890 or (123) 456-7890 }"
    ),

  landline_number: Yup.string()
    .trim()
    .matches(
      /^(?:\+(\d{1,3})\s?)?(\(\d{3}\)\s?\d{3}-\d{4})$/,
      "Invalid phone number format. { e.g., +1 (123) 456-7890 or (123) 456-7890 }"
    ),

  emergency_contact_name: Yup.string()
    .trim()
    .required("Emergency contact name is required"),

  emergency_contact_number: Yup.string()
    .trim()
    .matches(
      /^(?:\+(\d{1,3})\s?)?(\(\d{3}\)\s?\d{3}-\d{4})$/,
      "Invalid phone number format. { e.g., +1 (123) 456-7890 or (123) 456-7890 }"
    ),

  address_line_1: Yup.string().trim().required("Address Line 1 is required"),

  address_line_2: Yup.string().trim().required("Address Line 2 is required"),

  country_id: Yup.string().trim().required("Please select your country"),
  province_id: Yup.string().trim().required("Please select your province"),
  city_id: Yup.string().trim().required("Please select your city"),
  zip_code: Yup.string()
    .trim()
    .min(4, "Zip code must be at least 4 characters")
    .max(6, "Zip code cannot exceed 6 characters")
    .required("Zip code is required"),
  date_of_birth: Yup.date()
    .required("Date of Birth is required")
    .max(new Date(), "Date of Birth cannot be in the future")
    .test("age-limit", "You must be at least 18 years old", (value) => {
      if (!value) return false;
      const today = new Date();
      const birthDate = new Date(value);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age >= 18;
    }),
});

export const passwordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old password is required"),

  newPassword: Yup.string()
    .min(8, "New password must be at least 8 characters long")
    .required("New password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const profileDocsSchema = Yup.object().shape({
  documentName: Yup.string().required("Document name is required"),
  documentType: Yup.string().required("Document type is required"),
  document: Yup.mixed().required("Document is required")
});
